<template>
  <v-btn
    :icon="isDarkTheme ? 'mdi-white-balance-sunny' : 'mdi-weather-night'"
    @click="toggleTheme"
    variant="text"
    :title="isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'"
  />
</template>

<script>
import { useTheme } from "vuetify";
import { computed, onBeforeUnmount } from "vue";

export default {
  name: "ThemeToggle",
  setup() {
    const theme = useTheme();

    const isDarkTheme = computed(() => theme.current.value.dark);

    const emitChange = () => {
      window.dispatchEvent(
        new CustomEvent("theme-changed", {
          detail: { isDark: isDarkTheme.value },
        }),
      );
    };

    const applyTheme = (name) => {
      theme.change(name);
      emitChange();
    };

    const toggleTheme = () => {
      const next = isDarkTheme.value ? "nclLightTheme" : "nclDarkTheme";
      applyTheme(next);
      // User-explicit choice — persist and stop following system.
      localStorage.setItem("theme", next);
    };

    const savedTheme = localStorage.getItem("theme");
    const mql = window.matchMedia("(prefers-color-scheme: dark)");

    if (savedTheme === "nclDarkTheme" || savedTheme === "nclLightTheme") {
      applyTheme(savedTheme);
    } else {
      applyTheme(mql.matches ? "nclDarkTheme" : "nclLightTheme");
    }

    const onSystemChange = (e) => {
      if (localStorage.getItem("theme")) return; // user override wins
      applyTheme(e.matches ? "nclDarkTheme" : "nclLightTheme");
    };
    mql.addEventListener("change", onSystemChange);
    onBeforeUnmount(() => mql.removeEventListener("change", onSystemChange));

    return {
      theme,
      toggleTheme,
      isDarkTheme,
    };
  },
};
</script>
